module.exports = __webpack_public_path__ + "static/media/cc-dev-beginer.0bf44357.png";